import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-09-nikita-nishita-baliarsingh-guest.webp";
import ThumbImg from "../../assets/images/conversations/009.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";
import FacebookIcon from "../../assets/icons/conversations/facebook.svg";
import LinkedinIcon from "../../assets/icons/conversations/linkedin.svg";
import TwitterIcon  from "../../assets/icons/conversations/twitter.svg";

/* ─────────────────────────────────────────────
   PREFIX: np-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .np-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .np-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .np-hero { padding-top: 60px; padding-bottom: 60px; }
  .np-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .np-hero__left { display: flex; flex-direction: column; gap: 34px; }
  .np-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .np-hero__title.np-visible { opacity: 1; transform: translateY(0); }

  /* social share buttons */
  .np-hero__social {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.08s, transform 0.7s ease 0.08s;
  }
  .np-hero__social.np-visible { opacity: 1; transform: translateY(0); }
  .np-hero__social a {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    padding: 10px 14px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    text-decoration: none;
    transition: opacity 0.2s ease;
  }
  .np-hero__social a:hover { opacity: 0.85; }
  .np-hero__social a.fb { background: #3B5998; }
  .np-hero__social a.li { background: #0077B5; }
  .np-hero__social a.tw { background: #1DA1F2; }
  .np-hero__social a img { width: 18px; height: 18px; flex-shrink: 0; }

  .np-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .np-hero__spotify.np-visible { opacity: 1; transform: translateY(0); }
  .np-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .np-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .np-hero__right.np-visible { opacity: 1; transform: translateY(0); }

  .np-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .np-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .np-yt-thumb:hover img { opacity: 0.85; }
  .np-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .np-yt-thumb__play img { width: 40px; height: 44px; }
  .np-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .np-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .np-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .np-body.np-visible { opacity: 1; transform: translateY(0); }
  .np-body__label {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .np-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .np-body__para:last-child { margin-bottom: 0; }

  .np-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .np-guest.np-visible { opacity: 1; transform: translateY(0); }
  .np-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .np-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .np-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .np-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .np-inner { padding-left: 32px; padding-right: 32px; }
    .np-hero { padding-top: 32px; padding-bottom: 48px; }
    .np-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .np-hero__title { font-size: 24px; }
    .np-hero__left { gap: 16px; }
    .np-hero__social { gap: 10px; }
    .np-hero__social a { gap: 10px; font-size: 12px; padding: 10px 12px; }
    .np-guest__title { font-size: 24px; margin-bottom: 24px; }
    .np-guest__photo-bg { width: 260px; height: 300px; }
    .np-guest__name { font-size: 24px; margin-top: 18px; }
    .np-body__para { font-size: 14px; margin-bottom: 12px; }
    .np-body__label { font-size: 14px; margin-bottom: 12px; }
    .np-body { padding-bottom: 48px; }
    .np-guest { padding-bottom: 48px; }
    .np-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .np-inner { padding-left: 16px; padding-right: 16px; }
    .np-hero { padding-top: 51px; padding-bottom: 30px; }
    .np-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .np-hero__left { gap: 30px; }
    .np-hero__title { font-size: 30px; }
    .np-hero__social { gap: 11px; }
    .np-hero__social a { gap: 10px; font-size: 15px; padding: 10px 14px; }
    .np-body__para { font-size: 16px; margin-bottom: 10px; }
    .np-body__label { font-size: 16px; margin-bottom: 10px; }
    .np-guest__title { font-size: 30px; margin-bottom: 20px; }
    .np-guest__photo-bg { width: 100%; height: 386px; }
    .np-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .np-body { padding-bottom: 30px; }
    .np-guest { padding-bottom: 30px; }
    .np-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("np-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "REPLACE_EP09_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="np-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 09 Nexus Power"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="np-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 09 Nexus Power thumbnail" />
      <div className="np-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const socialRef  = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(socialRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="np-hero">
      <div className="np-inner">
        <div className="np-hero__grid">
          <div className="np-hero__left">
            <div ref={titleRef} className="np-hero__title">
              EP 09 | Electric Vehicles Powered By Farm Waste | Nexus Power
            </div>
            <div ref={socialRef} className="np-hero__social">
              <a href="https://www.facebook.com/sharer/sharer.php?u=" className="fb" target="_blank" rel="noreferrer">
                <img src={FacebookIcon} alt="Facebook" /> Facebook
              </a>
              <a href="https://www.linkedin.com/sharing/share-offsite/?url=" className="li" target="_blank" rel="noreferrer">
                <img src={LinkedinIcon} alt="LinkedIn" /> Linked in
              </a>
              <a href="https://twitter.com/intent/tweet?url=" className="tw" target="_blank" rel="noreferrer">
                <img src={TwitterIcon} alt="Twitter" /> Twitter
              </a>
            </div>
            <div ref={spotifyRef} className="np-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/15jgruKYqWIXW2fiEbuNAo?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 09 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="np-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="np-body">
      <div className="np-inner">
        <p className="np-body__label">Electric Vehicles powered by Farm Waste</p>
        <p className="np-body__para">
          In today's episode, we talk to two interesting entrepreneurs, twin sisters Nikita &amp; Nishita from Bhubaneshwar, who are working to create disruptions for the lithium-ion battery sector. Listed on the Forbes 30 Under 30 list for India, they have invented a battery with the same energy density as lithium-ion but is made from farm waste. Their peptide crystal batteries have been charged 8 times faster than Li-Ion in lab conditions. If this technology takes off, it could address the sustainability challenges of electric mobility globally.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="np-guest">
      <div className="np-inner">
        <h2 className="np-guest__title">Our Guest</h2>
        <div>
          <div className="np-guest__photo-bg">
            <img src={GuestImg} alt="Nikita and Nishita Baliarsingh" />
          </div>
          <p className="np-guest__name">Nikita &amp; Nishita BALIARSINGH</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep09NexusPower() {
  return (
    <>
      <style>{CSS}</style>
      <div className="np-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}